import { HttpApiMiddleware, HttpApiSecurity } from "@effect/platform";
import { CurrentUser, Unauthorized } from "@superwall/api-schema-utils";
export class Authn extends HttpApiMiddleware.Tag()("@superwall/api/dash-api/authn", {
    failure: Unauthorized,
    provides: CurrentUser.Context,
    security: {
        bearer: HttpApiSecurity.bearer
    }
}) {
}
